import { render } from "./ProdCategoriesEditorPage.vue?vue&type=template&id=68cb607a&ts=true"
import script from "./ProdCategoriesEditorPage.vue?vue&type=script&lang=ts"
export * from "./ProdCategoriesEditorPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__